import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMemberStatusWaitingFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.371 12.2605C12.371 12.6055 12.091 12.8855 11.746 12.8855C11.401 12.8855 11.121 12.6055 11.121 12.2605V7.73717C11.121 7.39217 11.401 7.11217 11.746 7.11217C12.091 7.11217 12.371 7.39217 12.371 7.73717V12.2605ZM8.88016 12.2605C8.88016 12.6055 8.60016 12.8855 8.25516 12.8855C7.91016 12.8855 7.63016 12.6055 7.63016 12.2605V7.73717C7.63016 7.39217 7.91016 7.11217 8.25516 7.11217C8.60016 7.11217 8.88016 7.39217 8.88016 7.73717V12.2605ZM10.0002 2.08301C5.63516 2.08301 2.0835 5.63384 2.0835 9.99967C2.0835 14.3647 5.63516 17.9163 10.0002 17.9163C14.366 17.9163 17.9168 14.3647 17.9168 9.99967C17.9168 5.63384 14.366 2.08301 10.0002 2.08301Z"
	})
});
export default SvgMemberStatusWaitingFill;
